import "../playerList/index.scss";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

import AppShell from "../../components/appShell";
import ViewPlayers from "../../components/viewPlayers";
import {
  activeBlock as activeBlockk,
  BiddingBlocks,
  selectbiddingBlocks,
  selectisLoggedIn,
  selectstatus,
} from "../../store/features/curatorSlice";

// The same list, opened from inside a running auction. It differs from the
// curator's own list only in what it offers at the end: a way back to the
// room rather than a way to start a category.
const PlayerListActive = () => {
  let dispatch = useDispatch();
  let navigate = useNavigate();
  let [key, setKey] = useState("elite");
  let isLoggedin = useSelector(selectisLoggedIn);
  let biddingBlocks = useSelector(selectbiddingBlocks);
  let status = useSelector(selectstatus);

  useEffect(() => {
    dispatch(activeBlockk());
    dispatch(BiddingBlocks());
  }, []);

  useEffect(() => {
    if (status === "Started Block!") {
      window.location.reload();
    }
  }, [status]);

  if (!isLoggedin) {
    return (
      <AppShell role="public">
        <h1 className="au-heading">Not signed in</h1>
        <p className="au-subheading">
          <Link to="/curator/login">Sign in as a curator</Link> to open the
          player list.
        </p>
      </AppShell>
    );
  }

  return (
    <AppShell role="curator">
      <div className="player-list">
        <header className="player-list-head">
          <div>
            <h1 className="au-heading">Player List</h1>
            <p className="au-subheading">
              The full pool while the auction is running.
            </p>
          </div>

          <div className="player-list-actions">
            <button
              type="button"
              className="au-btn ghost"
              onClick={() => navigate("/curator/auction")}
            >
              Back to auction room
            </button>
          </div>
        </header>

        <ViewPlayers blocks={biddingBlocks} keyState={{ key, setKey }} />
      </div>
    </AppShell>
  );
};

export default PlayerListActive;
